import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { MetaOptionService } from './meta-option.service'
import { MetaOptionSerializer } from './meta-option.serializer'
import * as fromMetaOption from './meta-option.reducer'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { MetaOptionEffects } from './meta-option.effects'

@NgModule({
  imports: [
    SharedModule,
    StoreModule.forFeature(
      fromMetaOption.FEATURE_NAME,
      fromMetaOption.metaOptionReducer
    ),
    EffectsModule.forFeature([MetaOptionEffects])
  ],
  declarations: [],
  exports: [],
  providers: [
    MetaOptionService,
    {
      provide: MetaOptionSerializer,
      useClass: MetaOptionSerializer
    }
  ]
})
export class MetaOptionModule {}
